import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/auth/Login.tsx";
import SignUpTeacher from "@/views/auth/SignUp_Teacher.tsx";
import SignUp from "@/views/auth/SignUp.tsx";
import Questionnaire from "@/views/auth/Questionnaire.tsx";
import Home from "@/views/Home.tsx";
import Balli from "@/views/balli/Balli.vue";
import BalliIntro from "@/views/balli/Intro.tsx";
import BalaOutro from "@/views/bala/Outro.tsx";
import BalliAbility from "@/views/balli/Ability.tsx";
import BalliAttitude from "@/views/balli/Attitude.tsx";
import BalliRegulation from "@/views/balli/Regulation.tsx";
import BalliGrit from "@/views/balli/Grit.tsx";
import BalliOutro from "@/views/balli/Outro.tsx";
import Bala from "@/views/bala/Bala.vue";
import BalaIntro from "@/views/bala/Intro.tsx";
import ReadingTask1 from "@/views/bala/reading_task_1/ReadingTask1.vue";
import ReadingTask1Intro from "@/views/bala/reading_task_1/Intro.tsx";
import ReadingTask1Passage from "@/views/bala/reading_task_1/Passage.tsx";
import ReadingTask1Understanding from "@/views/bala/reading_task_1/Understanding.tsx";
import ReadingTask1Questions from "@/views/bala/reading_task_1/Questions.tsx";
import ReadingTask2 from "@/views/bala/reading_task_2/ReadingTask2.vue";
import ReadingTask2Intro from "@/views/bala/reading_task_2/Intro.tsx";
import ReadingTask2Passage from "@/views/bala/reading_task_2/Passage.tsx";
import ReadingTask2Understanding from "@/views/bala/reading_task_2/Understanding.tsx";
import ReadingTask2Questions from "@/views/bala/reading_task_2/Questions.tsx";
import ReadingTask4 from "@/views/bala/reading_task_4/ReadingTask4.vue";
import ReadingTask4Intro from "@/views/bala/reading_task_4/Intro.tsx";
import ReadingTask4Passage from "@/views/bala/reading_task_4/Passage.tsx";
import ReadingTask4Understanding from "@/views/bala/reading_task_4/Understanding.tsx";
import ReadingTask4Questions from "@/views/bala/reading_task_4/Questions.tsx";
import ReadingTask5 from "@/views/bala/reading_task_5/ReadingTask5.vue";
import ReadingTask5Intro from "@/views/bala/reading_task_5/Intro.tsx";
import ReadingTask5Passage from "@/views/bala/reading_task_5/Passage.tsx";
import ReadingTask5Understanding from "@/views/bala/reading_task_5/Understanding.tsx";
import ReadingTask5Questions from "@/views/bala/reading_task_5/Questions.tsx";
import WritingTask1 from "@/views/bala/writing_task_1/WritingTask1.vue";
import WritingTask1Intro from "@/views/bala/writing_task_1/Intro.tsx";
import WritingTask1Response from "@/views/bala/writing_task_1/Response.tsx";
import WritingTask1Rating from "@/views/bala/writing_task_1/Rating.tsx";
import WritingTask1Questions from "@/views/bala/writing_task_1/Questions.tsx";
import WritingTask1Planning from "@/views/bala/writing_task_1/Planning.tsx";
import WritingTask2 from "@/views/bala/writing_task_2/WritingTask2.vue";
import WritingTask2Intro from "@/views/bala/writing_task_2/Intro.tsx";
import WritingTask2Response from "@/views/bala/writing_task_2/Response.tsx";
import WritingTask2Rating from "@/views/bala/writing_task_2/Rating.tsx";
import WritingTask2Questions from "@/views/bala/writing_task_2/Questions.tsx";
import WritingTask2Planning from "@/views/bala/writing_task_2/Planning.tsx";
import ReadingTask3 from "@/views/bala/reading_task_3/ReadingTask3.vue";
import ReadingTask3Intro from "@/views/bala/reading_task_3/Intro.tsx";
import ReadingTask3Passage from "@/views/bala/reading_task_3/Passage.tsx";
import ReadingTask3Understanding from "@/views/bala/reading_task_3/Understanding.tsx";
import ReadingTask3Questions from "@/views/bala/reading_task_3/Questions.tsx";
import TalkToMeJr from "@/views/talk2mejr/TalkToMeJr.vue";
import TalkToMeJrIntro from "@/views/talk2mejr/Intro.tsx";
import TalkToMeJrSetup from "@/views/talk2mejr/Setup.tsx";
import Consent from "@/views/consents/Consent.vue";
import Selection from "@/views/consents/Selection.tsx";
import Parent from "@/views/consents/Parent.tsx";
import Teacher from "@/views/consents/Teacher.tsx";
import Student from "@/views/consents/Student.tsx";
import TalkToMeJrTaskList from "./views/talk2mejr/TaskList";
import TalkToMeJrORF from "./views/talk2mejr/ORF";
import TalkToMeJrPicStory from "./views/talk2mejr/PictureStory";
import TalkToMeJrWorkingMemory from "./views/talk2mejr/WorkingMemory";
import TalkToMeJrEllision from "./views/talk2mejr/Ellision";
import TalkToMeJrStoryRetell from "./views/talk2mejr/StoryRetell";
import TalkToMeJrOutro from "./views/talk2mejr/Outro";
import TalkToMeJrPatternReasoning from "./views/talk2mejr/PatternReasoning";
import store from "./store/store";
import BalaWritingIntro from "@/views/bala/writing_task_1/WritingIntro";
import Dashboard from "./views/dashboard/Dashboard.vue";
import DashboardMain from "./views/dashboard/DashboardMain";

Vue.use(Router);

const router = new Router({
  routes: [
    { path: "/login", component: Login, name: "login" },
    { path: "/signup", component: SignUp, name: "signup" },
    {
      path: "/signup_teacher",
      component: SignUpTeacher,
      name: "signup_teacher"
    },
    { path: "/home", component: Home, name: "home" },
    {
      path: "/balli",
      component: Balli,
      children: [
        { path: "", component: BalliIntro, name: "balliHome" },
        { path: "ability", component: BalliAbility, name: "ability" },
        {
          path: "attitude",
          component: BalliAttitude,
          name: "balliAttitude"
        },
        {
          path: "regulation",
          component: BalliRegulation,
          name: "balliRegulation"
        },
        { path: "grit", component: BalliGrit, name: "balliGrit" },
        { path: "outro", component: BalliOutro, name: "balliOutro" }
      ]
    },
    {
      path: "/bala",
      component: Bala,
      children: [
        { path: "", component: BalaIntro },
        { path: "outro", component: BalaOutro, name: "balaOutro" },
        {
          path: "reading-task-1",
          component: ReadingTask1,
          children: [
            {
              path: "",
              component: ReadingTask1Intro,
              name: "balaRT1Intro"
            },
            {
              path: "passage",
              component: ReadingTask1Passage,
              name: "balaRT1Passage"
            },
            {
              path: "understanding",
              component: ReadingTask1Understanding,
              name: "balaRT1Understanding"
            },
            {
              path: "questions",
              component: ReadingTask1Questions,
              name: "balaRT1Questions"
            }
          ]
        },
        {
          path: "reading-task-2",
          component: ReadingTask2,
          children: [
            {
              path: "",
              component: ReadingTask2Intro,
              name: "balaRT2Intro"
            },
            {
              path: "passage",
              component: ReadingTask2Passage,
              name: "balaRT2Passage"
            },
            {
              path: "understanding",
              component: ReadingTask2Understanding,
              name: "balaRT2Understanding"
            },
            {
              path: "questions",
              component: ReadingTask2Questions,
              name: "balaRT2Questions"
            }
          ]
        },
        {
          path: "writing-intro",
          component: BalaWritingIntro,
          name: "balaWritingIntro"
        },
        {
          path: "writing-task-1",
          component: WritingTask1,
          children: [
            {
              path: "",
              component: WritingTask1Intro,
              name: "balaWT1Intro"
            },
            {
              path: "response",
              component: WritingTask1Response,
              name: "balaWT1Response"
            },
            {
              path: "rating",
              component: WritingTask1Rating,
              name: "balaWT1Rating"
            },
            {
              path: "questions",
              component: WritingTask1Questions,
              name: "balaWT1Questions"
            },
            {
              path: "planning",
              component: WritingTask1Planning,
              name: "balaWT1Planning"
            }
          ]
        },
        {
          path: "writing-task-2",
          component: WritingTask2,
          children: [
            { path: "", component: WritingTask2Intro, name: "balaWT2Intro" },
            {
              path: "response",
              component: WritingTask2Response,
              name: "balaWT2Response"
            },
            {
              path: "rating",
              component: WritingTask2Rating,
              name: "balaWT2Rating"
            },
            {
              path: "questions",
              component: WritingTask2Questions,
              name: "balaWT2Questions"
            },
            {
              path: "planning",
              component: WritingTask2Planning,
              name: "balaWT2Planning"
            }
          ]
        },
        {
          path: "reading-task-3",
          component: ReadingTask3,
          children: [
            {
              path: "",
              component: ReadingTask3Intro,
              name: "balaRT3Intro"
            },
            {
              path: "passage",
              component: ReadingTask3Passage,
              name: "balaRT3Passage"
            },
            {
              path: "understanding",
              component: ReadingTask3Understanding,
              name: "balaRT3Understanding"
            },
            {
              path: "questions",
              component: ReadingTask3Questions,
              name: "balaRT3Questions"
            }
          ]
        },
        {
          path: "reading-task-4",
          component: ReadingTask4,
          children: [
            { path: "", component: ReadingTask4Intro, name: "balaRT4Intro" },
            {
              path: "passage",
              component: ReadingTask4Passage,
              name: "balaRT4Passage"
            },
            {
              path: "understanding",
              component: ReadingTask4Understanding,
              name: "balaRT4Understanding"
            },
            {
              path: "questions",
              component: ReadingTask4Questions,
              name: "balaRT4Questions"
            }
          ]
        },
        {
          path: "reading-task-5",
          component: ReadingTask5,
          children: [
            { path: "", component: ReadingTask5Intro, name: "balaRT5Intro" },
            {
              path: "passage",
              component: ReadingTask5Passage,
              name: "balaRT5Passage"
            },
            {
              path: "understanding",
              component: ReadingTask5Understanding,
              name: "balaRT5Understanding"
            },
            {
              path: "questions",
              component: ReadingTask5Questions,
              name: "balaRT5Questions"
            }
          ]
        }
      ]
    },
    {
      path: "/talk2mejr",
      component: TalkToMeJr,
      children: [
        { path: "", component: TalkToMeJrIntro, name: "t2mejr-intro" },
        {
          path: "tasklist",
          component: TalkToMeJrTaskList,
          name: "t2mejr-tasklist"
        },
        {
          path: "setup",
          component: TalkToMeJrSetup,
          name: "t2mejr-setup"
        },
        { path: "orf", component: TalkToMeJrORF, name: "t2mejr-orf" },
        {
          path: "pic",
          component: TalkToMeJrPicStory,
          name: "t2mejr-pic"
        },
        {
          path: "workmem",
          component: TalkToMeJrWorkingMemory,
          name: "t2mejr-workmem"
        },
        {
          path: "ellision",
          component: TalkToMeJrEllision,
          name: "t2mejr-ellision"
        },
        {
          path: "retell",
          component: TalkToMeJrStoryRetell,
          name: "t2mejr-retell"
        },
        {
          path: "outro",
          component: TalkToMeJrOutro,
          name: "t2mejr-outro"
        },
        {
          path: "patreason",
          component: TalkToMeJrPatternReasoning,
          name: "t2mejr-pattern"
        }
      ]
    },
    {
      path: "/",
      component: Consent,
      children: [
        { path: "", component: Selection, name: "consent-selection" },
        { path: "parent", component: Parent, name: "consent-parent" },
        {
          path: "teacher",
          component: Teacher,
          name: "consent-teacher"
        },
        {
          path: "student",
          component: Student,
          name: "consent-student"
        }
      ]
    },
    {
      path: "/dashboard",
      component: Dashboard,
      // name: "dashboard",
      children: [{ path: "", component: DashboardMain, name: "dashboard-main" }]
    }
  ]
});

router.beforeEach((to: any, from: any, next: any) => {
  let loggedIn = store.getters.user.loggedIn;
  if (
    to.name &&
    ["login", "signup"]
      .map((ele: string) => to.name.includes(ele))
      .includes(true)
  ) {
    loggedIn ? next({ name: "home" }) : next();
    return;
  }

  if (to.name && to.name.includes("consent")) {
    loggedIn ? next({ name: "home" }) : next();
    return;
  }

  if (loggedIn) {
    next();
    return;
  }

  next("/");
});

export default router;
